import { useState, useEffect } from 'react';

import { tvMetrics } from '../lib/tvMetrics';

const REF_HEIGHT = 1080;

interface TvScale {
  rowHeight: number;
  scale: number;
}

function availableSize() {
  if (typeof window === 'undefined') return { height: REF_HEIGHT, width: 1920 };
  const bannerHeight =
    document.querySelector('.zipa-environment')?.getBoundingClientRect().height ?? 0;
  return { height: Math.max(0, window.innerHeight - bannerHeight), width: window.innerWidth };
}

export function useTvScale(): TvScale {
  const [size, setSize] = useState(availableSize);

  useEffect(() => {
    const update = () => setSize(availableSize());
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return tvMetrics(size.height, 0, size.width);
}
